module.exports = __webpack_public_path__ + "img/google.79275998.svg";